import React, { useState, useEffect } from 'react';
import { useAppContext } from '../Context';
import { useTranslation } from '../TranslationContext';
import { motion } from 'framer-motion';

const Home = () => {
	const { codeFailed, codeFormat, startsWithMessage } = useAppContext();
	const { t } = useTranslation();
	const [errorMessage, setErrorMessage] = useState(null);

	const codeFormatMessage = codeFormat.split(';').join(' or ');

	useEffect(() => {
		if (codeFailed > 0) {
			setErrorMessage(
				<>
					{t('codeErrorMessageHead')}
					<p style={{ fontSize: '12px', maxWidth: '300px', margin: '0 auto', fontFamily: 'Trebuchet MS' }}>
						{codeFailed === 1 && (
							<>
								{t('codeErrorMessage1a')} {startsWithMessage}<br />
								{t('codeErrorMessage1b')}<br />
								{codeFormatMessage}.<br /><br />
								{t('codeErrorMessageVisitUs')} <a href="https://www.imageinsight.com/support-cantfind/">{t('codeErrorMessagePhotoSupport')}</a>
							</>
						)}
						{codeFailed === 2 && (
							<>
								{t('codeErrorMessage2a')} {t('codeErrorMessage2b')}<br /><br />
								{t('codeErrorMessageVisitUs')} <a href="https://www.imageinsight.com/support-cantfind/">{t('codeErrorMessagePhotoSupport')}</a>
							</>
						)}
					</p>
				</>
			);
		} else {
			setErrorMessage(null);
		}
	}, [codeFailed, codeFormatMessage, startsWithMessage, t]);

	return (
		<div className="landing">
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				exit={{ opacity: 0 }}
				transition={{ duration: 1, ease: 'easeInOut' }}
				className="welcomeMessage"
			>
				{/*//param example <p>{t('greeting', { name: 'User' })}</p>*/}
				{errorMessage ? errorMessage : (
					<>
						{t('welcome') != "-ignore-" && (<h1>{t('welcome')}</h1>)}
						{t('welcomeMessage')}
					</>
				)}
			</motion.div>
		</div>
	);
};

export default Home;